import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import * as tcActions from 'features/tc/duck';
import * as staticActions from 'shared/ducks/staticDuck';
import { TcStatus, TcInfo, TcLocations, TcEvents } from 'features/tc';
import { Accordion, AlertNotice, PageNotFound, Spinner } from 'shared/components';
import { INSTITUTION_STATUS as tcStatus } from 'shared/constants';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import concat from 'lodash/concat';
import isArray from 'lodash/isArray';

import './TcDashboard.scss';

class TcDashboard extends Component {
  constructor(props) {
    super(props);

    const { tcId } = props.match.params;

    this.state = {
      noPermissions: false,
      cyclesData: [],
    };

    const self = this;

    props.actions.clearTCAction();
    props.actions.getTC(tcId).then((data) =>
      props.actions.getTCCycles(data.id, tcStatus.active).then((cycles) => {
        cycles.forEach((cycle) => {
          props.actions.getTcCycleFilteredEvents(cycle.id).then((events) => {
            if (isArray(events)) {
              cycle.events = events;
              self.setState((prevState) => ({
                cyclesData: [...prevState.cyclesData, cycle],
              }));
            }
          });
        });
      })
    );
    props.actions.getServerDateTime();

    this.onBack = this.onBack.bind(this);
  }

  onBack() {
    this.props.actions.clearTCAction();
    this.props.history.goBack();
  }

  render() {
    const { testCenter, loading, serverDateTime } = this.props;
    const { cyclesData } = this.state;

    if (this.state.noPermissions) {
      return <PageNotFound />;
    }

    if (loading) {
      return <Spinner />;
    }

    const now = moment(serverDateTime).format('YYYY-MM-DD');
    const cyclesCompleted = sortBy(
      filter(cyclesData, (cycle) => moment(cycle.cycle.endDate).format('YYYY-MM-DD') < now),
      (cycle) => cycle.cycle.startDate,
      ['desc']
    );
    const cyclesFuture = sortBy(
      filter(cyclesData, (cycle) => moment(cycle.cycle.endDate).format('YYYY-MM-DD') >= now),
      (cycle) => cycle.cycle.startDate
    );

    // let nextEvent = {};
    // forEach(cyclesData, (cycle) => {
    //   forEach(cycle.events, (event) => {
    //     const currentDate = event.rescheduleDate || (isWindowEvent(event.testingEvent) ? event.testingEvent.endTestDate : event.testingEvent.testDate);
    //
    //     if ((moment(currentDate).add(7, 'd')).isSameOrAfter(now)  &&
    //       (event.testCenterEventStatus === ASSIGNMENT_STATUS.open || event.testCenterEventStatus === ASSIGNMENT_STATUS.reschedule) &&
    //       (isEmpty(nextEvent) || moment(currentDate) < moment(nextEvent.rescheduleDate || nextEvent.testingEvent.testDate))
    //     ) {
    //       nextEvent = event;
    //     }
    //   });
    // });

    return (
      !isEmpty(testCenter) &&
      !!testCenter.id && (
        <section className="TcDashboard col p-0">
          <h4>{testCenter.name}</h4>

          <TcStatus tc={testCenter} />

          {/*<TcCurrentEvent event={nextEvent} serverDateTime={serverDateTime}/>*/}
          <TcInfo tc={testCenter} />

          <h4>{this.props.t('testCenter.dashboard.availableTcLabel')}</h4>
          {isEmpty(cyclesFuture) && isEmpty(cyclesCompleted) && (
            <AlertNotice message={this.props.t('testCenter.dashboard.noAvailableTc')} />
          )}
          <Accordion startPosition={0}>
            {concat(cyclesFuture, cyclesCompleted).map((cycle) => (
              <div
                key={cycle.id}
                data-trigger={
                  <span>
                    <span>
                      {cycle.cycle.name}({cycle.testCenterProgram.program.name})
                    </span>
                    <span
                      className={
                        moment(cycle.cycle.endDate).format('YYYY-MM-DD') < now
                          ? 'completed'
                          : moment(cycle.cycle.startDate).format('YYYY-MM-DD') > now
                          ? 'future'
                          : 'current'
                      }
                    />
                  </span>
                }>
                <TcLocations tcCycle={cycle} />
                <TcEvents tcCycle={cycle} />
              </div>
            ))}
          </Accordion>
          <button className="btn btn-outline ml-0 btn-back" onClick={this.onBack}>
            {this.props.t('common.labels.back')}
          </button>
        </section>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    serverDateTime: state.statics.serverDateTime,
    testCenter: state.tc.testCenter,
    tcCycles: state.tc.tcCycles,
    loading: state.tc.tcCycles.loading || state.tc.tcCycle.loading || state.tc.loading,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ ...tcActions, ...staticActions }, dispatch) };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TcDashboard));

TcDashboard.propTypes = {
  testCenter: PropTypes.shape({}).isRequired,
  actions: PropTypes.shape({
    getTC: PropTypes.func,
    getTcCycle: PropTypes.func,
    getTcCycleEvents: PropTypes.func,
    clearTCAction: PropTypes.func,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}),
  }).isRequired,
  t: PropTypes.func.isRequired,
};

TcDashboard.defaultProps = {};
